import { apiClient } from './apiClient';

const base = '/api/transcripts';

export const transcriptsService = {
  list: (params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });
    const queryString = queryParams.toString();
    return apiClient.get(`${base}${queryString ? `?${queryString}` : ''}`);
  },
  get: id => apiClient.get(`${base}/${id}`),
  analyze: id => apiClient.post(`${base}/${id}/analysis`),
  generateFromRecording: id => apiClient.post(`${base}/${id}/generate-from-recording`),
};

export default transcriptsService;
